import type { FC } from "react";
import { type SxProps, type Theme } from "@mui/material";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import { config, PagePaths } from "@/admin/shared/constants";

export interface LogoProps {
  sx?: SxProps<Theme>;
}

export const Logo: FC<LogoProps> = ({ sx }) => {
  return (
    <Box
      component={Link}
      to={PagePaths.admin}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        ...sx,
      }}
    >
      <img src={config.logoUrl} alt="logo" style={{ maxWidth: "120px" }} />
    </Box>
  );
};
